var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 12427"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M21.7842 20.7988C19.9938 20.7988 18.5176 22.2437 18.5176 24.0654C18.5176 25.8558 19.9624 27.3321 21.7842 27.3321C23.5746 27.3321 25.0508 25.8872 25.0508 24.0654C25.0194 22.2751 23.5746 20.7988 21.7842 20.7988Z",
  fill: "#00538F"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M27.5316 5.22043C27.4688 5.22043 27.3746 5.18902 27.2803 5.18902H7.49218L7.17808 3.08457C6.98962 1.70254 5.79605 0.666016 4.38261 0.666016H1.83842C1.14741 0.666016 0.582031 1.23139 0.582031 1.92241C0.582031 2.61342 1.14741 3.1788 1.83842 3.1788H4.38261C4.53966 3.1788 4.6653 3.30444 4.69671 3.46148L6.64412 16.7164C6.89539 18.3811 8.34024 19.6375 10.0364 19.6375H23.1028C24.7361 19.6375 26.1496 18.4754 26.4951 16.8735L28.5367 6.66528C28.6624 6.00568 28.2226 5.34607 27.5316 5.22043Z",
  fill: "#00538F"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_5"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M13.7747 23.9084C13.7119 22.1809 12.2671 20.7988 10.5395 20.7988C8.71775 20.8931 7.33572 22.4007 7.39854 24.1911C7.46136 25.9186 8.8748 27.3006 10.6023 27.3006H10.6652C12.4555 27.2064 13.869 25.6988 13.7747 23.9084Z",
  fill: "#00538F"
}))));

function SvgShoppingCartBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartBlue);
export default __webpack_public_path__ + "static/media/shopping-cart-blue.64e4996d.svg";
export { ForwardRef as ReactComponent };